/* V88 timeline — the track runs like a progress bar, one stage at a time.

   When the row comes into view, card 1's node lights, its segment fills to
   the next node, card 2's node lights, and so on. Each step waits for the
   one before it, so the stages cannot start together whatever AOS or the
   rail are doing. CSS owns the look (.is-on lights a node, .is-fill runs a
   segment); this only decides when. */
(function () {
  var NODE_MS = 300;   // the node lighting up
  var FILL_MS = 1300;  // one segment filling — keep in step with the CSS

  function run(rail) {
    var cards = rail.querySelectorAll('.v88-tl__card');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      cards.forEach(function (c) { c.classList.add('is-on', 'is-fill'); });
      return;
    }
    /* ON THE PHONE THE ROW IS A CAROUSEL (v88-rail.js binds Swiper to it),
       and the bar runs on into cards that are off screen. So the carousel
       follows the bar: as a node lights, its card slides into view. Anyone
       who swipes it takes over, and it stops following. */
    var handsOn = false;
    function carousel() {
      /* Looked up each step: the rail can be bound after the bar starts. */
      var sw = rail.swiper;
      if (sw && !sw.v88TlHooked && sw.on) {
        sw.v88TlHooked = true;
        sw.on('touchStart', function () { handsOn = true; });
      }
      return sw && !sw.destroyed && !sw.isLocked ? sw : null;
    }
    var i = 0;
    (function step() {
      var card = cards[i];
      if (!card) return;
      var sw = carousel();
      if (sw && !handsOn && i > 0) sw.slideTo(i, 700);
      card.classList.add('is-on');
      setTimeout(function () {
        card.classList.add('is-fill');
        setTimeout(function () { i++; step(); }, FILL_MS);
      }, NODE_MS);
    })();
  }

  function init() {
    document.querySelectorAll('.v88-tl__rail:not([data-v88-tl-ready])').forEach(function (rail) {
      rail.setAttribute('data-v88-tl-ready', '');
      /* A page can ask for no motion on the phone (the section's still_phone,
         OneLife, Sep 24): the line is drawn whole and continuous from the
         start, and the carousel moves only when swiped. Desktop keeps the run. */
      if (rail.hasAttribute('data-v88-tl-still') && window.matchMedia && window.matchMedia('(max-width: 899px)').matches) {
        rail.querySelectorAll('.v88-tl__card').forEach(function (c) { c.classList.add('is-on', 'is-fill'); });
        return;
      }
      if (!('IntersectionObserver' in window)) { run(rail); return; }
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        run(rail);
      }, { threshold: 0.35 });
      io.observe(rail);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
